export const LUCKY_WHEEL_START_LEVEL = 30;

export const LUCKY_WHEEL_SPAWN_INCREMENT: number = 20;
export const LUCKY_WHEEL_LEVEL_UNLOCK: number = 10;